<ng-container *transloco="let t">

  @if (validatorResult) {
    <div>
      <div>
        @if (rowName) {
          <div class="pt-2 pb-1">
            <div [style.padding-left]="((indent))+'rem'" class="grey-row">
             <span class="fw-bold">
                {{ rowName }}
             </span>
            </div>
          </div>
        }
        <div>
          @if (errorMessages.length > 0) {
            @for (errorMessage of errorMessages;track errorMessage) {
              <div [style.padding-left]="(indent*2)+'rem'">
                <span class="fw-bold">
                  {{
                    errorMessage.field
                  }}
              </span>
                <span>
                {{
                    errorMessage.message
                  }}
              </span>
              </div>
            }
          }
          @if (validatorResult.subErrors) {
            @for (subError of validatorResult.subErrors.keys();track subError) {
              <validator-result-message [validatorResult]="validatorResult.subErrors.get(subError)" [indent]="indent+1"
                                        [key]="subError"></validator-result-message>
            }
          }
        </div>
      </div>
    </div>
  }
</ng-container>
